import { useAuthContext } from "@/contexts/AuthContext";
import { useQRStats } from "@/hooks/useQRStats";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import StatsSummary from "@/pages/statistics/components/StatsSummary";
import ScanChart from "@/pages/statistics/components/ScanChart";
import CountryBreakdown from "@/pages/statistics/components/CountryBreakdown";
import DeviceBreakdown from "@/pages/statistics/components/DeviceBreakdown";
import RecentScansTable from "@/pages/statistics/components/RecentScansTable";

export default function StatisticsPage() {
  const { user } = useAuthContext();
  const { stats, loading } = useQRStats();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pt-16">
        <div className="max-w-7xl mx-auto px-6 py-10">
          {/* Header */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Tarama İstatistikleri</h1>
              <p className="text-sm text-gray-500 mt-1">
                {user
                  ? "QR kodlarınızın performansını gerçek zamanlı takip edin"
                  : "Örnek istatistikler görünüyor — giriş yaparak kendi verilerinizi görün"}
              </p>
            </div>
            <div className="flex items-center gap-3">
              <select className="px-4 py-2 bg-white border border-gray-200 rounded-xl text-sm text-gray-600 focus:outline-none focus:border-emerald-400 cursor-pointer">
                <option>Son 7 Gün</option>
                <option>Son 30 Gün</option>
                <option>Son 3 Ay</option>
                <option>Bu Yıl</option>
              </select>
              <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl text-sm text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-download-2-line"></i>
                Dışa Aktar
              </button>
            </div>
          </div>

          {/* Loading */}
          {user && loading && (
            <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
              <div className="w-4 h-4 border-2 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
              Veriler yükleniyor...
            </div>
          )}

          {/* Summary Cards */}
          <StatsSummary stats={stats || undefined} />

          {/* Charts Row */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
            <div className="lg:col-span-2">
              <ScanChart dailyScans={stats?.dailyScans} />
            </div>
            <div className="flex flex-col gap-6">
              <CountryBreakdown breakdown={stats?.countryBreakdown} />
              <DeviceBreakdown deviceStats={stats?.deviceBreakdown} />
            </div>
          </div>

          {/* Recent Scans Table */}
          <div className="mt-6">
            <RecentScansTable scans={stats?.recentScans} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}